<div class="popover" [ngClass]="{ 'popover--in-box': inBox }" [ngStyle]="{ 'width.px': width ?? 280 }">
  <button class="popover__close" type="button" (click)="popoverService.close()">
    <app-icon [icon]="'close'" [width]="24"></app-icon>
  </button>
  @if (mobileTitle) {
    <app-title class="popover__mobile-title" [tag]="'h6'">{{ mobileTitle }}</app-title>
  }
  <div class="popover__main">
    <div class="popover__content" [ngStyle]="{ padding: padding }" (scroll)="contentScroll($event)">
      <ng-content></ng-content>
    </div>
  </div>
</div>
